// extracted by mini-css-extract-plugin
export default {"blockContent":"SiderSplitter_blockContent__p3V2u","infoText":"SiderSplitter_infoText__G1PtN"};